@if(activiteAdherent=='gpo'){
<mat-form-field appearance="outline" class="filiale-selector">
  <mat-label>Filiale</mat-label>

  <input
    type="text"
    matInput
    placeholder="Filiale"
    [formControl]="filialeCtrl"
    [matAutocomplete]="autoFiliale"
    (focus)="onInputFocus()"
  />

  <mat-autocomplete
    #autoFiliale="matAutocomplete"
    (optionSelected)="onFilialeSelected($event.option.value)"
    autoActiveFirstOption
  >


    @for (filiale of filteredFiliales$ | async; track filiale) {
      <mat-option [value]="filiale">
        {{ filiale }}
      </mat-option>
    }
  </mat-autocomplete>

  @if (filialeCtrl.value) {
    <button
      matSuffix
      mat-icon-button
      aria-label="Clear"
      (click)="onClearFiliale()"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
</mat-form-field>
}
